<template>
    <div class="activity">
        <img src="assets/images/day1.png" alt="Day 1 Image" />

        <h3>Niagara Falls</h3>
        <p>9AM to 11AM • $45 USD</p>

        <p class="description">A Pocket PC is a handheld computer, which features many of the same capabilities as a modern PC. These handy little devices allow individuals to retrieve and store e-mail messages, create a contact file, coordinate appointments, surf the internet, exchange text messages and more.</p>

        <div class="directions">
            <div class="map"></div>
            <div class="content">
                <h4>How to get there</h4>

                <div class="route">
                    <div class="stop">
                        <div class="stop-visual">
                            <div class="stop-circle"></div>
                        </div>
                        <div class="stop-details">
                            <div class="stop-name">Canadian International Airport</div>
                        </div>
                    </div>

                    <div class="stop walk">
                        <div class="stop-visual">
                            <div class="stop-circle"
                                v-for="n in 3"
                                v-bind:key="n"></div>
                        </div>
                        <div class="stop-details">
                            <div class="walk-details">Walk
                                <div>About 3 mins</div>
                            </div>
                        </div>
                    </div>

                    <div class="stop train">
                        <div class="stop-visual">
                            <div class="connection"></div>
                            <div class="stop-circle">
                                <i class="train-icon"></i>
                            </div>
                            <div class="stop-circle"></div>
                        </div>
                        <div class="stop-details">
                            <div class="stop-name">Canada Station
                                <div class="train-line">James Line 2</div>
                            </div>

                            <div class="walk-details">Ride 3 stops (14 min)</div>

                            <div class="stop-name">Poutine Station</div>
                        </div>
                    </div>

                    <div class="stop walk">
                        <div class="stop-visual">
                            <div class="stop-circle"
                                v-for="n in 5"
                                v-bind:key="n"></div>
                        </div>
                        <div class="stop-details">
                            <div class="walk-details">Walk
                                <div>About 20 mins</div>
                            </div>
                        </div>
                    </div>

                    <div class="stop">
                        <div class="stop-visual">
                            <div class="stop-circle"></div>
                        </div>
                        <div class="stop-details">
                            <div class="stop-name">Niagara Falls</div>
                            <div class="stop-location">Niagara Falls, Ontario, Canada</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ActivityItem'
    }
</script>

<style scoped lang="scss">
    .activity:first-child {
        margin-top: 55px;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }

    .activity:not(:first-child) {
        margin-top: 103px;

        @media all and (max-width: $breakpoint) {
            margin-top: 30px;
        }
    }


    .activity > img {
        display: block;
        width: 100%;
    }


    .activity h3 {
        margin-bottom: 0;
        text-transform: uppercase;
        font-weight: $heavy;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 56px;
            line-height: 28px;
            font-size: 28px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            line-height: 18px;
            font-size: 18px;
        }
    }


    .activity h3 + p {
        font-weight: $medium;
        color: $accent;

        @media all and (max-width: $breakpoint) {
            font-size: 12px;
        }
    }


    .activity .description {
        text-align: justify;

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 37px;
            line-height: 30px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 10px;
            line-height: 24px;
        }
    }


    .directions {

        @media all and (min-width: $breakpoint + 1) {
            display: flex;
            margin-top: 59px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .directions .map {
        background-color: hsl(200, 0%, 95%);
        width: 100%;
        flex-shrink: 0;

        @media all and (min-width: $breakpoint + 1) {
            max-width: 50%;
            height: 100vh;
            max-height: 470px;
        }

        @media all and (max-width: $breakpoint) {
            max-width: none;
            min-height: 300px;
            height: auto;
            max-height: none;
        }
    }


    .directions .content {
        margin-left: 16px;

        @media all and (min-width: $breakpoint + 1) {
            padding-left: 32px;
        }

        @media all and (max-width: $breakpoint) {
            margin: 10px 0 0 0;
        }
    }


    .directions h4 {
        margin: 0;
        text-transform: uppercase;
        line-height: 28px;
        font-weight: $heavy;
        font-size: 24px;

        @media all and (max-width: $breakpoint) {
            font-size: 16px;
        }
    }


    .route {
        margin-top: 20px;

        @media all and (max-width: $breakpoint) {
            margin: 10px auto 0;
            padding-left: 24px;
        }
    }


    .stop {
        display: flex;
        align-items: center;
    }

    .stop:not(:first-child) {
        margin-top: 10px;
    }

    .stop.train {
        align-items: stretch;
    }

    .stop.walk {
        position: relative;
    }

    .stop.walk::before {
        content: "";
        background: url('/assets/images/icons/walk.svg') no-repeat center;
        background-size: contain;
        position: absolute;
        display: block;
        top: 0;
        left: -32px;
        bottom: 0;
        margin: auto 0;
        width: 24px;
        height: 24px;

        @media all and (max-width: $breakpoint) {
            left: -24px;
        }
    }


    .stop-visual {
        width: 24px;
        flex-shrink: 0;
    }

    .train .stop-visual {
        position: relative;
        display: flex;
        flex-direction: column;
    }


    .train .train-icon {
        width: 18px;
        height: 18px;
    }


    .stop-circle {
        background-color: #E0E0E0;
        margin: 0 auto;
        width: 24px;
        height: 24px;
        border-radius: 50%;
    }

    .stop:first-child .stop-circle {
        background-color: #2B97D4;
        border: 5px solid #C9E6F6;
    }

    .walk .stop-circle {
        width: 12px;
        height: 12px;
    }

    .walk .stop-circle:not(:first-child) {
        margin-top: 10px;
    }

    .stop:last-child .stop-circle {
        background-color: #000;
        position: relative;
    }

    .stop:last-child .stop-circle::before,
    .stop:last-child .stop-circle::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border-radius: 50%;
    }

    .stop:last-child .stop-circle::before {
        background-color: #FFF;
        width: 22px;
        height: 22px;
    }

    .stop:last-child .stop-circle::after {
        background-color: #000;
        width: 14px;
        height: 14px;
    }

    .train .stop-circle {
        background-color: #FFF;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .train .stop-circle:last-child {
        margin: auto auto 5px;
        width: 18px;
        height: 18px;
    }


    .stop-details {
        margin-left: 16px;
    }


    .stop-name {
        font-weight: $heavy;

        @media all and (min-width: $breakpoint + 1) {
            line-height: 28px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            line-height: 20px;
            font-size: 16px;
        }
    }


    .walk-details {
        font-weight: $book;
        font-size: 14px;
        color: $dark-gray;
    }

    .train .walk-details {
        margin: 30px 0;

        @media all and (max-width: $breakpoint) {
            margin: 15px 0;
        }
    }


    .walk-details div {
        padding-left: 19px;
        font-size: 8px;
    }


    .train .connection {
        background-color: #923BEE;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 24px;
    }


    .train-line {
        background-color: #923BEE;
        width: max-content;
        padding: 2px 4px;
        line-height: initial;
        font-weight: $medium;
        font-size: 14px;
        color: #FFF;
    }


    .stop-location {
        font-size: 10px;
        color: $dark-gray;
    }
</style>
